import { useQuery } from "@tanstack/react-query";

import {
  fetchAllTotemMovements,
  fetchTotemById,
  fetchTotemMovements,
  TotemMovementDateFilters,
  TotemWithRelations,
} from "~/services/totemService";

export const TOTEM_DETAIL_QUERY_KEY = ["totem-detail"];
export const TOTEM_MOVEMENTS_QUERY_KEY = ["totem-movements"];

export function useTotemDetail(id: string | undefined) {
  return useQuery<TotemWithRelations | null, Error>({
    queryKey: [...TOTEM_DETAIL_QUERY_KEY, id],
    queryFn: () => (id ? fetchTotemById(id) : Promise.resolve(null)),
    enabled: !!id,
  });
}

export function useTotemMovements(totemId: string | undefined) {
  return useQuery({
    queryKey: [...TOTEM_MOVEMENTS_QUERY_KEY, totemId],
    queryFn: () =>
      totemId ? fetchTotemMovements(totemId) : Promise.resolve([]),
    enabled: !!totemId,
  });
}

export function useAllTotemMovements(filters?: TotemMovementDateFilters) {
  return useQuery({
    queryKey: [...TOTEM_MOVEMENTS_QUERY_KEY, "all", filters?.from, filters?.to],
    queryFn: () => fetchAllTotemMovements(filters),
  });
}
